module.exports = __webpack_public_path__ + "img/meIcon.a9253085.svg";